import { useState } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import ExpandIcon from "../../../../icons/Expand";
import CellTreeConditionLineItem from "./CellTreeConditionLineItem";
import NumberBadge from "../../../../components/NumberBadge";
import OverflowTooltip from "../../../../components/OverflowTooltip";

type Props = {
  title: string;
  group?: number;
  items?: MetadataSidebarCellLayoutItem[];
  onToggleCell?: (id: number) => void;
  expanded?: boolean;
};

const CellTreeCondition = ({
  title,
  group,
  items,
  onToggleCell,
  expanded: _expanded,
}: Props) => {
  const [expanded, setExpanded] = useState(_expanded);
  const active = items?.some((item) => item.active);

  const lastOneActive = items?.filter((item) => item.active).length === 1;

  return (
    <Collapse in={expanded} collapsedSize={56} className="small">
      <>
        <Box px={1} mt={3} display="flex" alignItems="center">
          <IconButton
            size="small"
            color="primary"
            onClick={() => setExpanded(!expanded)}
          >
            <ExpandIcon
              style={expanded ? { transform: "rotate(90deg)" } : {}}
            />
          </IconButton>
          <Box ml={1} mr="auto">
            {active ? (
              <Box display="flex" alignItems="center">
                <div style={{ maxWidth: 150 }}>
                  <OverflowTooltip title={title}>
                    <b>{title}</b>
                  </OverflowTooltip>
                </div>
                <NumberBadge label="Group number" value={`${group}`} />
              </Box>
            ) : (
              <Box display="flex" alignItems="center">
                <div style={{ maxWidth: 150 }}>
                  <OverflowTooltip title={title}>
                    <Typography
                      color="textSecondary"
                      variant="inherit"
                      component="span"
                      onClick={() => {
                        if (!active && items && onToggleCell) {
                          onToggleCell(items[0] && items[0].cell_id);
                          setExpanded(true);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {title}
                    </Typography>
                  </OverflowTooltip>
                </div>
                <NumberBadge label="Group number" value={`${group}`} />
              </Box>
            )}
          </Box>
        </Box>

        {items?.map((item, index) => (
          <CellTreeConditionLineItem
            key={index}
            title={item.name}
            disabled={item.active && lastOneActive}
            active={item.active}
            onClick={() => onToggleCell && onToggleCell(item.cell_id)}
          />
        ))}
      </>
    </Collapse>
  );
};

export default CellTreeCondition;
